import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  overlay: {
    "&:before": {
      position: "fixed",
      // background: "#000",
      opacity: 0.8,
      top: 0,
      left: 0,
      zIndex: 99999,
      height: "100vh",
      width: "100%",
      content: '""',
    },
  },
  content: {
    position: "absolute",
    zIndex: 999999,
    left: 0,
    top: -150,
    "& img": {
      width: 1300,
      objectFit: 'contain',
      height: '100%'
    },
  },
  targetCompletionConfetti: {
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 999999
  },
  confettiMsg: {
    background: '#F0FFF1',
    color: "#02A561",
    border: 'solid 1px #85D6B0',
    borderRadius: 10,
    padding: '12px 30px',
    position: 'fixed',
    top: 120,
    "& svg": {
      width: 36,
      height: 36,
      marginRight: 14,
    }
  }
}));

export default useStyles;
